export default "__VITE_ASSET__BNkvV$qa__"